import {
  formatNormalNumber,
  createKpiTileItem,
} from '../../../../utils/helper';
import { KpiHandler, ValueRealizationData } from './types';
import { KpiData } from 'components/redesign/KpiTile/types';

const noOfTubes: KpiHandler = {
  type: 'KpiTile',
  handler: (data: ValueRealizationData): KpiData => {
    const { noOfTubes } = data;

    const formattedValue = formatNormalNumber(noOfTubes);

    return createKpiTileItem('Number of Tubes', formattedValue, []);
  },
};

export default noOfTubes;
